import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Combobox Design Guidelines",
  "title": "Combobox",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="combobox" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  A combobox is the combination of a text input and a list.
      </LeadParagraph>
      <h2>{`Usage`}</h2>
      <p>{`The list is designed to help the user arrive at a value, but the value does not necessarily have to come from that list. Do not think of it like a Select, but more of a text input with some suggestions.`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.123552123552116%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAmklEQVQoz62SyQoEIQxE/f8/1Yu441pNpZmmD3PRmUBJCPqskKjeO1JKCCGgtQbGWgs78b6vSinQWotyzuAHBO+Ib2ptAlYsGGPgvZfCLuxWh/cJcw6oMYbA6O4MdqvWijknFA8CWfglyBEgHcYY4ZyTlk/EIOdxyAkTyPwztWMgE64NXe6uy3tlnpZ5WGsFeuLuq0MO5B8i8AKD+xTAPu88TAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "combobox example",
            "title": "combobox example",
            "src": "/version/4.9.1/static/e974ac0053848595c890560648cf3a1a/e3189/combobox-example.png",
            "srcSet": ["/version/4.9.1/static/e974ac0053848595c890560648cf3a1a/a2ead/combobox-example.png 259w", "/version/4.9.1/static/e974ac0053848595c890560648cf3a1a/6b9fd/combobox-example.png 518w", "/version/4.9.1/static/e974ac0053848595c890560648cf3a1a/e3189/combobox-example.png 1035w", "/version/4.9.1/static/e974ac0053848595c890560648cf3a1a/f32b7/combobox-example.png 1136w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <h2>{`Multi Combobox`}</h2>
      <p>{`The multi combobox allows the user to select more than one option from the list and add their own.`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "37.83783783783784%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA1UlEQVQoz62RzWpCQQyF55Hrqn2DbnwCC6UvYzfF1VVBoXah4N+9KnpnnEkyOZKh3baiPfARGMJJcsYxEYgSRBj/IbdcrjCfL9A0DVIixJjAzBARUBl2HcwEVYXrvY7ReXrHy9sYz90BHh77+BgsUNcrtK1HzrmY/wazIIRUjN3nrEE12mD2tcNkWqMarrGtj2jbE0I4I6WEGOOfWK9d5ojO8P4AQO/Kzs61bV0IQff7gzKLvWnOWur3hKsxiYg67335EFvbnCyzW/jJ0zFzcSaiuzFdAPf0bsQew3G/AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "multi combobox example",
            "title": "multi combobox example",
            "src": "/version/4.9.1/static/8c026f2fead6791655860d4b3ceb4bd4/e3189/multi-combobox-example.png",
            "srcSet": ["/version/4.9.1/static/8c026f2fead6791655860d4b3ceb4bd4/a2ead/multi-combobox-example.png 259w", "/version/4.9.1/static/8c026f2fead6791655860d4b3ceb4bd4/6b9fd/multi-combobox-example.png 518w", "/version/4.9.1/static/8c026f2fead6791655860d4b3ceb4bd4/e3189/multi-combobox-example.png 1035w", "/version/4.9.1/static/8c026f2fead6791655860d4b3ceb4bd4/f32b7/multi-combobox-example.png 1136w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      